import { getCookie } from "./cookies";
import { handleToast } from "./handleToast";

export class Compare {
    constructor() {
        this.set();
        this.init();
    }

    set() {
        this.comparePageWrapper = document.querySelector(".js-compare-page-template");
        this.loader = this.comparePageWrapper ? this.comparePageWrapper.nextElementSibling : null;
        this.cookieCompareName = "mda_compare";
        this.addToCompareClass = "js-add-to-compare";
        this.removeFromCompareClass = "js-remove-from-compare";
        this.disabledClass = "-disabled";
    }
    init() {
        this.updateHeaderCount();
        window.addEventListener("click", (e) => {
            const {target} = e;
            const cookieDataAttribute = target.getAttribute("data-compare-product-id");
            const removeFromCompareProductBox = target.getAttribute("data-remove-from-compare");

            if (cookieDataAttribute) {
                if (target.classList.contains("-disabled")) return;
                this.handleCompareElementClick(target, cookieDataAttribute);
            }

            if (target.classList.contains("js-clear-compare") && this.comparePageWrapper) {
                this.clearCompare();
            }

            if (removeFromCompareProductBox) {
                this.clearCompare(removeFromCompareProductBox);
            }

        })
    }

    async clearCompare(singleRemove = false) {
        try {
            this.loader.classList.add("-active");
            const formData = new FormData();
            formData.append("action", "remove_from_compare");
            formData.append("nonce", ajax.nonce);
            if (singleRemove) {
                formData.append("product_to_remove", singleRemove);
            }
            const req = await fetch(ajax.url, {
                method: "POST",
                body: formData
            });

            const data = await req.json();

            const {html, status, message} = data.data;

            if (status && message) {
                handleToast(status, message);
            }
            this.updateHeaderCount();

            if (html) {
                this.comparePageWrapper.innerHTML = html;

                const elementPosition = this.comparePageWrapper.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - 250;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }


        } catch (error) {
            console.log(error);
        } finally {
            this.loader.classList.remove("-active");
        }
    }

    async handleCompareElementClick(target, productId) {

        try {
            target.classList.remove(this.disabledClass);

            this.beforeClick(target);
            const formData = new FormData();

            formData.append("product_id", productId);
            formData.append("action", "handle_compare");
            formData.append("nonce", ajax.nonce);

            const req = await fetch(ajax.url, {
                method: "POST",
                body: formData
            });

            const {data} = await req.json();

            const {status, message, is_disabled, is_added} = data;

            if (status && message) {
                handleToast(status, message);
            }

            if (is_disabled) {
                target.classList.add(this.disabledClass);
            }

            if (status === "success") {
                target.classList.remove(!is_added ? this.removeFromCompareClass : this.addToCompareClass);
                target.classList.add(!is_added ? this.addToCompareClass : this.removeFromCompareClass);
                this.updateHeaderCount();
            }

        } catch (error) {
            console.log(error);
        } finally {
            this.afterClick(target);
        }
    }

    handleCookie(type = "add", productId) {
        const cookie = getCookie(this.cookieCompareName);
        if (type === "add") {
            if (!cookie) {
                const value = JSON.stringify([productId]);
                setCookie(this.cookieCompareName, value, 365);
            } else {
                const currentCookieVal = JSON.parse(cookie);
                currentCookieVal.push(productId);
                setCookie(this.cookieCompareName, JSON.stringify(currentCookieVal), 365);
            }
        } else {
            const currentCookieVal = JSON.parse(cookie);
            const cookieValToSet = currentCookieVal.filter((item) => item !== productId);
            setCookie(this.cookieCompareName, JSON.stringify(cookieValToSet), 365);
        }
    }

    beforeClick(target) {
        target.classList.add("-active");
    }

    afterClick(target) {
        target.classList.remove("-active");
    }

    updateHeaderCount() {
        const counterEl = document.querySelector(
            ".header-middle__cart-count.-compare"
        );
        if (!counterEl) return;

        const cookie = getCookie(this.cookieCompareName);
        const count = this.getCompareCountFromCookie(cookie);
        counterEl.textContent = count;
    }

    getCompareCountFromCookie(cookieValue) {
        if (!cookieValue) return 0;

        const candidates = [cookieValue];
        try {
            candidates.push(decodeURIComponent(cookieValue));
        } catch (e) {}

        for (const candidate of candidates) {
            try {
                const parsed = JSON.parse(candidate);
                if (Array.isArray(parsed)) {
                    return parsed.length;
                }
            } catch (e) {}
        }

        return 0;
    }
}
